const rewards_es = require('./rewards.json')
export default rewards_es